<template>
  <div
    style="margin-top: 0px;"
  >
    <div>
      <div class="filtering">

        <div class="search-toggle">

          <p>{{ $t('SearchBy') }}</p>
          <div>
            <p
              :class="{ active2: !toggleSarch }"
              @click="showCustomerName()"
            >
              {{ $t('Location Name') }}
            </p>
            <p
              :class="{ active2: toggleSarch }"
              @click="showArticleName()"
            >
              {{ $t('ArticleNumber') }}
            </p>
          </div>
        </div>
        <div v-if="show == true">
          <div>
            <div class="black">
              <b-icon-search
                v-if="searchCN == ''"
                class="search1"
                style="position: absolute; left: 5px; top: 12px"
              />
              <b-icon-x-circle
                v-else-if="searchCN != '' && !noSearch"
                class="search1"
                style="position: absolute; right: 20px; top: 12px; cursor: pointer"
                @click="searchCN = ''"
              />
              <input
                v-model="searchCN"
                type="text"
                autocomplete="off"
                name="search-box"
                :placeholder="$t('Location Name')"
                :style="getLocationByPagination.length > 0 && noSearchTwo ? 'border-radius: 8px 8px 0px 0px' : ''"
                @keyup="inputChanged"
                @keydown.down="onArrowDown"
                @keydown.up="onArrowUp"
              >
            </div>
            <div
              v-if="getLocationByPagination.length > 0 && noSearchTwo"
              ref="scrollContainer2"
              class="dropdrop"
              style="
              display: inline-block;
              overflow: auto;
              position: absolute;
              background: white;
              width: 229px;
              box-shadow: none;
            "
              :style="getLocationByPagination.length > 7 ? 'height: 210px' : 'height: auto'"
            >
              <div
                v-for="(result, index) in getLocationByPagination"
                ref="options2"
                :key="index"
                :class="{ 'is-active': index === arrowCounter2 }"
                style="cursor: pointer"
                class="search-item"
                @click="searchByCn(result ); noSearchTwo = false"
              >
                <p style="margin: 0">
                  {{ result.locationName }}
                </p>
              </div>
              <div
                v-if="getLocationByPagination.length == 0"
                class="search-item"
              >
                <p>{{ $t('NoResult') }}</p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="show == false">
          <div class="black">
            <b-icon-search
              v-if="searchAN == ''"
              class="search2"
              style="position: absolute; left: 5px; top: 12px"
            />
            <b-icon-x-circle
              v-else-if="searchAN != '' && !noSearchTwo"
              class="search1"
              style="position: absolute; right: 20px; top: 12px; cursor: pointer"
              @click="searchAN = ''"
            />
            <input
              v-model="searchAN"
              type="text"
              name="search-box"
              :style="getArticleNameLike.length > 0 && noSearchTwo ? 'border-radius: 8px 8px 0px 0px' : ''"
              :placeholder="$t('ArticleNumber')"
              @keyup="inputChanged2"
              @keydown.down="onArrowDown2"
              @keydown.up="onArrowUp2"
            >
          </div>
          <div
            v-if="getArticleNameLike.length > 0 && noSearchTwo"
            ref="scrollContainer2"
            class="dropdrop"
            style="
              display: inline-block;
              overflow: auto;
              position: absolute;
              background: white;
              width: 229px;
              box-shadow: none;
            "
            :style="getArticleNameLike.length > 7 ? 'height: 210px' : 'height: auto'"
          >
            <div
              v-for="(result, index) in getArticleNameLike"
              :key="index"
              ref="options2"
              style="cursor: pointer"
              :class="{ 'is-active': index === arrowCounter2 }"
              class="search-item"
              @click="searchByAn(result); noSearchTwo = false"
            >
              <p style="margin: 0">
                {{ result.articleNumber }}
              </p>
            </div>
            <!-- <div
                v-if="getFilteredSuppliersByCN.length == 0"
                class="search-item"
              >
                <p>Sorry. No Results.</p>
              </div> -->
          </div>
        </div>
      </div>
      <div>
        <button
          style="border: 0; width: 48px; height: 36px; background: #FF274F; border-radius: 5px; margin-right: 10px;"
          @click="downloadPDF"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="white"
            class="bi bi-file-earmark-pdf"
            viewBox="0 0 16 16"
          >
            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
            <path d="M4.603 14.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.697 19.697 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.712 5.712 0 0 1-.911-.95 11.651 11.651 0 0 0-1.997.406 11.307 11.307 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.266.266 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.71 12.71 0 0 1 1.01-.193 11.744 11.744 0 0 1-.51-.858 20.801 20.801 0 0 1-.5 1.05zm2.446.45c.15.163.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.876 3.876 0 0 0-.612-.053zM8.078 7.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z" />
          </svg>
        </button>
      </div>
      <div
        style="width: 100%;padding-top: 16px; margin-top: 15px;"
        class="scroll"
      >
        <table
          ref="exportable_table"
          class="team_table"
        >
          <thead>
            <tr>
              <th>
                {{ $t('ArticleNumber') }}
              </th>
              <th>
                {{ $t('Location Name') }}
              </th>
              <th>
                {{ $t('State') }}
              </th>
              <th>
                {{ $t('Actions') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in getProductInStockLocationPagination"
              :key="index"
            >
              <td>
                {{ item.articleNumber }}
              </td>
              <td>
                {{ item.locationName }}
              </td>
              <td>
                <button
                  v-if="item.currentState == 'InStock'"
                  v-b-modal.modal-sold-modal
                  class="editButton"
                  @click="changeState(item.productInStockId )"
                >
                  {{ $t("Sell") }}
                </button>
                <p
                  v-else
                  class="p-0 m-0 ml-50"
                >
                  {{ item.currentState == 'InStock' ? 'Sold Successfully' : '' }}
                </p>
              </td>
              <td
                v-b-toggle.edit-product-stock-location
                @click="editItem(item.productInStockId, item.locationId, item.locationName)"
              >

                <p
                  class="p-0 m-0 ml-50"
                >
                  <button class="editButton">
                    {{ $t('Edit') }}
                  </button>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <b-pagination
          v-if="getTotalItemsForOrders > 15"
          v-model="pageNumber"
          :total-rows="getTotalItemsForOrders"
          :per-page="pageSize"
          first-number
          last-number
          align="fill"
          prev-class="prev-itemi"
          next-class="next-itemi"
          class="mt-1 mb-0"
        >
          <template #prev-text>
            <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
          </template>
          <template #next-text>
            <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
          </template>
        </b-pagination>
      </div>
    </div>
    <EditProductInStockLocationToggle
      :edit="editInStock"
      @onCancelToggle="onCancelToggle"
      @editPassive="editProductLocation"
    />
    <EditProductInStockLocation
      :edit="editInStock"
      @editPassive="editProductLocation"
    />
    <div
      v-if="isSidebarOpen"
      class="backdrop"
    />
    <SoldChangeStage :prop="propData" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import AddSupplierModal from '@/modals/AddSupplierModal.vue';
// import EditRowModal from '@/modals/EditRowModal.vue';
// import { countryCallingCodes } from '../countryCodes'
import EditProductInStockLocationToggle from '@/components/productsInStock/modals/EditProductInStockLocationToggle.vue'
import moment from 'moment';
import jsPDF from 'jspdf';
import EditProductInStockLocation from '../location/modals/EditProductInStockLocation.vue'
import SoldChangeStage from './modals/SoldChangeStage.vue'
import 'jspdf-autotable';

/*  eslint-env es6  */
export default {
  components: {
    EditProductInStockLocation,
    SoldChangeStage,
    EditProductInStockLocationToggle,
  },
  // props: {
  //   materialId: {
  //     type: String,
  //     default: '',
  //   },
  // },
  data() {
    return {
      isSidebarOpen: false,
      // countryCallingCode: countryCallingCodes,
      toggleSarch: false,
      show: true,
      searchCN: '',
      searchAN: '',
      noSearch: false,
      noSearchTwo: false,
      propData: {},
      locationtype: null,
      locationByType: null,
      pageNumber: 1,
      // editInStock: {
      //   productInStockId: null,
      //   locationId: null,
      // },
      pageSize: 15,
      editLocationn: {
        // locationId: '',
        locationName: '',
        locationType: '',
        notes: '',
      },
      deactivateItemId: {},
      totalItems: '',
      rows: [],
      arrowCounter: 0,
      arrowCounter2: 0,
      enterPressed: false,
      editInStock: {
        productInStockId: null,
        locationId: null,
        locationName: null,
      },
    };
  },
  computed: {
    ...mapGetters([
      'getProductInStockLocationPDF',
      'getSuppliers',
      'getCurrentPageForSuppliers',
      'getTotalItemsForSuppliers',
      'getLoggedInUser',
      'getFilteredSuppliersBySN',
      'getFilteredSuppliersByCN',
      'getLocation',
      'getLocationTypes',
      'getLocationsByType',
      'getLocationByPagination',
      'getLocationByPaginationTotalItems',
      'getFilterLocation',
      'getOrderItemLocation',
      'getTotalItemsForOrders',
      'getFirstNames',
      'getArticleNameLike',
      'getProductInStockLocationPagination',
    ]),
  },
  watch: {
    pageNumber(value) {
      this.productInStock_location_Pagination({
        orderItemId: null,
        articleNumber: null,
        pageNumber: value,
        pageSize: this.pageSize,
      })
    },
    searchCN(value) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value == '') {
        // this.fshijCN();
          this.productInStock_location_Pagination({
            orderItemId: null,
            articleNumber: null,
            locationName: null,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          })
        } else if (this.enterPressed) {
        // eslint-disable-next-line no-useless-return
          return
        } else {
          this.locationPagination({ locationType: 'WarehouseForProductInStock', pageNumber: 1, pageSize: 15 });

          this.noSearchTwo = true
        }
      }, 500)
    },
    searchAN(value) {
      if (value == '') {
        // this.fshijCN();
        this.productInStock_location_Pagination({
          orderItemId: null,
          articleNumber: null,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        })
      } else if (this.enterPressed) {
        // eslint-disable-next-line no-useless-return
        return
      } else {
        this.productInStock_articleNumberLike(value);
        this.noSearchTwo = true
      }
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {

    ...mapActions([
      'loadProductStockLocationPDF',
      'productInStock_articleNumberLike',
      'loadSuppliers',
      'addSupplier',
      'editSupplier',
      'getSuppliersCompanyNameLikeORContactNameLike',
      'deactivateSupplierById',
      'changeLoadingtoTrue',
      'filterSuppliersBySN',
      'resetFilteredSupplierBySN',
      'filterSuppliersByCN',
      'resetFilteredSupplierByCN',
      'addLocation',
      'editLocation',
      'locationi',
      'loadLocationTypes',
      'locations_by_type',
      'locationPagination',
      'filterLocationBy',
      'productInStock_location_Pagination',
      'firstNames',
      'productInStockLocation_articleNumberLike',
      'updateProductStatus',
      'change_productInStock_locationn',
      'orderItem_location_Pagination',
    ]),
    async fetch() {
      try {
        await this.productInStock_location_Pagination({
          orderItemId: null,
          articleNumber: null,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        })
          .then((res) => {
            console.log(res);
            // this.changeLoadingtoTrue(true)
          })
      } catch (e) {
        console.log(e);
        // this.changeLoadingtoTrue(false)
      }
    },
    editProductLocation(value) {
      // console.log(value)
      this.change_productInStock_locationn({
        object: value,
        successCallback: () => {
          this.productInStock_location_Pagination({
            orderItemId: null,
            articleNumber: null,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          })
        },
      })
    },
    onCancelToggle() {
      this.isSidebarOpen = false
    },
    editItem(product, location, locationName) {
      this.isSidebarOpen = true
      this.locations_by_type('WarehouseForProductInStock')
      this.editInStock.productInStockId = product;
      this.editInStock.locationId = location
      this.editInStock.locationName = locationName
    },
    onArrowDown2(ev) {
      ev.preventDefault()
      if (this.arrowCounter2 < this.getArticleNameLike.length - 1) {
        this.arrowCounter2 += 1;
        this.fixScrolling2();
      }
    },

    onArrowUp2(ev) {
      ev.preventDefault()
      if (this.arrowCounter2 > 0) {
        this.arrowCounter2 -= 1;
        this.fixScrolling2()
      }
    },
    onArrowDown(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.getLocationByPagination.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },
    onArrowUp(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling()
      }
    },
    inputChanged(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') { return; }
      // this.getFilteredOrdersbyON = [];

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByCn(this.getLocationByPagination[this.arrowCounter])
        this.removeLists()
        this.arrowCounter = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    changeState(value) {
      const obj = {
        productInStockId: value,
        newState: 'Sold',
      }

      this.propData = obj

      // this.updateProductStatus({
      //   object: obj,
      //   successCallback: () => {
      //     this.productInStock_location_Pagination({
      //       orderItemId: null,
      //       articleNumber: null,
      //       pageNumber: this.pageNumber,
      //       pageSize: this.pageSize,
      //     })
      //   },
      // })
    },

    downloadPDF() {
      // this.changeLoadingtoTrue(false);

      // axios
      //   .get('https://logisticstoredata.digitwebsite.ch/api/v1/extendedStoresByPagination?PageNumber=1&PageSize=12')
      this.loadProductStockLocationPDF({
        orderItemId: null,
        articleNumber: null,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
        .then(() => {
          // const data = response.data;
          // const items = data.items;

          const tableContent = this.generateTableContent(this.getProductInStockLocationPDF.items);

          const totalPages = this.getProductInStockLocationPDF.totalPages;
          const additionalPromises = [];
          for (let pageNumber = 2; pageNumber <= totalPages; pageNumber++) {
            additionalPromises.push(this.downloadPage(pageNumber));
          }

          Promise.all(additionalPromises).then((additionalTableContents) => {
            additionalTableContents.forEach((additionalTableContent) => {
              tableContent.body.push(...additionalTableContent.body);
            });

            const footerIcon = 'data:image/png;base64,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'

            const pdfDocument = this.generatePDF(tableContent, footerIcon);
            pdfDocument.save('Location.pdf');
          });
          // this.changeLoadingtoTrue(true);
        })
        .catch((error) => {
          console.error('Error downloading the data:', error);
          // this.changeLoadingtoTrue(false);
        });
    },
    downloadPage(pageNumber) {
      // axios
      //   .get(
      //     `https://logisticstoredata.digitwebsite.ch/api/v1/extendedStoresByPagination?PageNumber=${pageNumber}&PageSize=12`,
      //   )
      // this.changeLoadingtoTrue(false);

      return this.loadProductStockLocationPDF({
        orderItemId: null,
        articleNumber: null,
        pageNumber,
        pageSize: this.pageSize,
      })

        .then(() => {
          // const data = response.data;
          // const items = data.items;
          // this.changeLoadingtoTrue(true);

          return this.generateTableContent(this.getProductInStockLocationPDF.items);
        })
        .catch((error) => {
          console.error('Error downloading the data:', error);
          // this.changeLoadingtoTrue(false);
        });
    },
    generateTableContent(items) {
      // const headers = [`${this.$t('FilialeName')}`, 'GLN', 'Email', 'Phone', 'Street', 'City', 'Country', 'Trucks', 'Manager', 'TeamLeader', 'Co-TeamLeader'];
      const headers = [`${this.$t('ArticleNumber')}`, `${this.$t('LocationName')}`,
        `${this.$t('State')}`];
      const body = items.map((item) => {
        return [
          item.articleNumber,
          item.locationName,
          item.currentState,
        ]
      });

      return { headers, body };
    },
    // generatePDF(tableContent) {
    //   const { headers, body } = tableContent;

    //   // eslint-disable-next-line new-cap
    //   const doc = new jsPDF();
    //   doc.autoTable({
    //     head: [headers],
    //     body,
    //   });

    //   return doc;
    // },
    generatePDF(tableContent, footerIcon) {
      const { headers, body } = tableContent;

      // eslint-disable-next-line new-cap
      const doc = new jsPDF();

      const iconWidth = 30; // Adjust the width of the icon as needed
      const iconHeight = 10; // Adjust the height of the icon as needed
      const iconY = 10; // Adjust the vertical position of the icon (top)

      // Draw a blue background rectangle that spans the entire width of the paper
      const blueBackgroundX = 0;
      const blueBackgroundWidth = doc.internal.pageSize.getWidth();
      const blueBackgroundHeight = 25; // Adjust the height as needed
      doc.setFillColor(36, 47, 110); // Blue color
      doc.rect(blueBackgroundX, 0, blueBackgroundWidth, blueBackgroundHeight, 'F');

      // Add the logo image on top of the blue background on the top left
      const iconX = 15; // Adjust the horizontal position of the icon (left)
      doc.addImage(footerIcon, 'PNG', iconX, iconY, iconWidth, iconHeight);



      const staticContent = () => {
        // Draw blue background for the footer
        const blueBackgroundFooterX = 0;
        const blueBackgroundFooterY = doc.internal.pageSize.getHeight() - 15;
        const blueBackgroundFooterWidth = doc.internal.pageSize.getWidth();
        const blueBackgroundFooterHeight = 25;
        doc.setFillColor(36, 47, 110); // Blue color (RGB values)
        doc.rect(blueBackgroundFooterX, blueBackgroundFooterY, blueBackgroundFooterWidth, blueBackgroundFooterHeight, 'F');

        // Add URL
        const url = 'www.digitbusiness.ch';
        const urlX = 30;
        const urlY = doc.internal.pageSize.getHeight() - 7;
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text(url, urlX, urlY, { align: 'center' });

        // Add address
        const address = 'Steinstrasse 56, 8003 Zürich, Switzerland';
        const addressX = 165;
        const addressY = doc.internal.pageSize.getHeight() - 7;
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text(address, addressX, addressY, { align: 'center' });
      };

      // Add the logo to the top left corner of the first page
      // const iconWidth = 30; // Adjust the width of the icon as needed
      // const iconHeight = 10; // Adjust the height of the icon as needed
      // const iconX = 15; // Adjust the horizontal position of the icon (left)
      // const iconY = 5; // Adjust the vertical position of the icon (top)
      // doc.addImage(footerIcon, 'PNG', iconX, iconY, iconWidth, iconHeight);

      const currentTime = moment().format('DD-MM-YYYY, HH:mm:ss');
      const timeX = doc.internal.pageSize.getWidth() / (10 / 9);
      const timeY = 10;
      doc.setFontSize(10);
      doc.setTextColor(255, 255, 255); // Black color
      doc.text(currentTime, timeX, timeY, { align: 'right' });

      // Add the title
      const title = this.$t('MaterialVariantName');
      const titleX = doc.internal.pageSize.getWidth() / 2;
      const titleY = 20; // Adjust the vertical position of the title
      doc.setFontSize(18);
      doc.setTextColor(255, 255, 255); // Black color
      doc.text(title, titleX, titleY, { align: 'center' });

      // Add the author
      const authorX = 15;
      const authorY = 30; // Adjust the vertical position of the author
      const author = `${this.getLoggedInUser.firstName} ${this.getLoggedInUser.lastName}`;
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text(`${this.$t('Author')}: ${author}`, authorX, authorY);

      // Add the table
      const tableOptions = {
        startY: authorY + 5, // Adjust the vertical position of the table
        time: moment().format('DD-MM-YYYY'),
        head: [headers],
        body,
        headStyles: {
          fillColor: [36, 47, 110], // Set the background color for the header
          textColor: [255, 255, 255], // Set the text color for the header
        },
        afterPageContent: staticContent,
      };
      doc.autoTable(tableOptions);

      // const iconWidthh = 30; // Adjust the width of the icon as needed
      // const iconHeightt = 10; // Adjust the height of the icon as needed
      // // const iconX = doc.internal.pageSize.getWidth() / 2 - iconWidth / 2;
      // // const iconY = doc.internal.pageSize.getHeight() - 35; // Adjust the vertical position of the icon
      // const iconXX = doc.internal.pageSize.getWidth() / 2 - iconWidth / 2;
      // const iconYY = doc.internal.pageSize.getHeight() - 18; // Adjust the vertical position of the icon

      // doc.addImage(footerIcon, 'PNG', iconXX, iconYY, iconWidthh, iconHeightt);

      // Add a horizontal line
      const hrLineY = doc.internal.pageSize.getHeight() - 20;
      const hrLineX1 = 50;
      const hrLineX2 = doc.internal.pageSize.getWidth() - 50;
      doc.setLineWidth(0.5); // Adjust the line thickness as needed
      doc.line(hrLineX1, hrLineY, hrLineX2, hrLineY);

      // Add the address
      // const address = 'Bahnhofstrasse 276, 4563 Gerlafingen, Switzerland';
      // const addressX = doc.internal.pageSize.getWidth() / 2;
      // const addressY = doc.internal.pageSize.getHeight() - 2;
      // doc.setFontSize(8);
      // doc.setTextColor(0, 0, 0); // Black color
      // doc.text(address, addressX, addressY, { align: 'center' });

      return doc;
    },

    dateFormat(value) {
      return moment(value).format('DD-MM-YYYY, HH:mm')
    },


    inputChanged2(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') { return; }
      // this.getFilteredOrdersbyON = [];

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByAn(this.getArticleNameLike[this.arrowCounter2])
        this.removeLists()
        this.arrowCounter2 = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    fixScrolling() {
      const liH = this.$refs.options[this.arrowCounter].clientHeight;
      console.log(liH)
      this.$refs.scrollContainer.scrollTop = liH * this.arrowCounter;
    },
    fixScrolling2() {
      const liH = this.$refs.options2[this.arrowCounter2].clientHeight;
      console.log(liH)
      this.$refs.scrollContainer2.scrollTop = liH * this.arrowCounter2;
    },
    showArticleName() {
      this.toggleSarch = true;
      this.searchAN = '';
      this.show = false;
      this.productInStock_location_Pagination({
        orderItemId: null,
        articleNumber: null,
        locationId: null,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
    },
    showCustomerName() {
      this.toggleSarch = false;
      this.searchCN = '';
      this.show = true
      this.productInStock_location_Pagination({
        orderItemId: null,
        articleNumber: null,
        locationId: null,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
    },
    async searchByAn(value) {
      console.log(value)
      this.searchAN = value.articleNumber
      this.noSearch = false
      await this.productInStock_location_Pagination({
        orderItemId: null,
        articleNumber: this.searchAN,
        locationId: null,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
    },
    async searchByCn(value) {
      console.log(value)

      this.searchCN = value.locationName
      this.noSearchTwo = false
      await this.productInStock_location_Pagination({
        orderItemId: null,
        articleNumber: null,
        locationId: value.locationId,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
    },

    removeLists() {
      this.noSearch = false;
      this.noSearchTwo = false;
      this.resetFilteredSupplierBySN();
      this.resetFilteredSupplierByCN();
    },
  },
};
</script>

<style scoped lang="scss">

.team_table td {
  padding: 11px 9px;
}
.active2 {
  font-weight: bold;
  color: $base-color;
}
.active2{
  color: $base-color;
  font-weight: bold;
}

@media screen and (max-width: 1340px){
  .main{
    padding: 75px 15px 15px 90px;
  }
}

@media screen and (max-width: 1200px) {
  .scroll {
    overflow-x: scroll;
  }

}

.dropdrop::-webkit-scrollbar {
  display: none;

}

.dropdrop {
  display: inline-block;
  overflow: auto;
  position: absolute;
  background: white;
  width: 227px;
  box-shadow: none;
}

input[name="search-box"] {
  display: block;
  max-width: 500px;
  width: 95%;
  padding: 0.5rem 1rem;
  padding-left: 25px;
}
.search-item {
  padding: 5px;
  max-width: 500px;
  width: 100%;
  font-weight: 400;
  color: #82868c;
  font-size: 1rem;
  border-bottom: 1px solid #e8e8e8;
}

.search-item:last-child {
  border-bottom: none;
}

.search-item:hover {
  background: #82868c;
  color: white;
}

.search-item hr {
  color: lightgray;
  border-top: none;
  margin: -1.3rem 0 0.5rem 0;
}

.is-active {
  background-color: #dedede;
}
</style>
